import React, { Component } from 'react';
import { CKEditor } from "ckeditor4-react";

export class HeadingPatternComponent extends Component {
  constructor(props) {
    super(props);
  }

  renderCKEditor(content, index, sort, field) {
    return (
      <CKEditor
        initData={content}
        type="inline"
        className="content-editable"
        onChange={(event) => this.props.handleChangeAlignText(sort, event, field)}
        config={{
          width: '100%',
          height: '300',
          language: 'ja',
          allowedContent: true,
          autoParagraph: false,
          extraPlugins: "justify,font,colorbutton,colordialog",
          font_names: '游ゴシック/Yu Gothic Medium;游明朝/Yu Mincho;ヒラギノ角ゴ Pro W3;メイリオ/メイリオ, Microsoft Sans Serif, Osaka, Arial, sans-serif;ＭＳ ゴシック/ＭＳ ゴシック;ＭＳ 明朝/ＭＳ 明朝;ＭＳ Ｐゴシック/ＭＳ Ｐゴシック;ＭＳ Ｐ明朝/ＭＳ Ｐ明朝;Verdana/Verdana;Arial/Arial;Courier New/Courier New;Times New Roman/Times New Roman',
          toolbar: [
            { name: 'paragraph', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight'] },
            { name: 'styles', items: ['Font'] },
            { name: 'colors', items: ['TextColor'] },
            { name: 'styles', items: ['FontSize'] }
          ],
          fontSize_sizes: '10px(PC) ~ 8.8px(SP)/1rem;12px(PC) ~ 10.56px(SP)/1.2rem;14px(PC) ~ 12.32px(SP)/1.4rem;16px(PC) ~ 14.08px(SP)/1.6rem;18px(PC) ~ 15.84px(SP)/1.8rem;20px(PC) ~ 17.6px(SP)/2rem;22px(PC) ~ 19.36px(SP)/2.2rem;24px(PC) ~ 21.12px(SP)/2.4rem;26px(PC) ~ 22.88px(SP)/2.6rem;28px(PC) ~ 24.64px(SP)/2.8rem;36px(PC) ~ 31.68px(SP)/3.6rem;48px(PC) ~ 42.24px(SP)/4.8rem;72px(PC) ~ 63.36px(SP)/7.2rem',
          title: false,
          versionCheck: false
        }}
      />
    );
  }

  renderContent() {
    const { content, isEdit, index, sort } = this.props;

    if (isEdit) {
      return (
        <div className="heading block_header_2 editor contenteditable overflow-hidden" data-target="1">
          <h3 className="headline-image-text-block">{this.renderCKEditor(content.headline_pattern, index, sort, "headline_pattern")}</h3>
          <p>{this.renderCKEditor(content.subheadline_pattern, index, sort, "subheadline_pattern")}</p>
        </div>
      );
    }

    return (
      <div className="heading block_header_2 editor contenteditable overflow-hidden" data-target="1">
        <h3 className="headline-image-text-block" dangerouslySetInnerHTML={{ __html: content.headline_pattern }} />
        <p dangerouslySetInnerHTML={{ __html: content.subheadline_pattern }} />
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderContent()}
      </React.Fragment>
    );
  }
}

export default HeadingPatternComponent;
